import { Store } from '@/store/types';
import { CommandWithFiles } from '@/application/types';

export interface DefaultParameter {
  email: string;
}

export interface UserParameter {
  email: string;
}

export function attachDefaultStoreValues<T>(body: T, rootState: Store): T & DefaultParameter {
  return {
    ...body,
    email: rootState.authentication.user.email ?? undefined,
  };
}

export function attachUserStoreValues<T>(body: T, rootState: Store): T & UserParameter {
  return {
    ...body,
    email: rootState.authentication.user.email ?? undefined,
  };
}

export function attachDefaultStoreValuesToCommandWithFiles<T extends CommandWithFiles>(command: T, rootState: Store): T {
  return {
    ...command,
    body: {
      ...command.body,
      email: rootState.authentication.user.email ?? undefined,
    }
  };
}
